<div class="ap-cr-crop-row-big-detail-box">
  <div class="ap-cr-front-row-noselect">
    <ap-responsive-text [text]="mainCropLabel"></ap-responsive-text>
  </div>
  <div class="ap-cr-back-row-noselect">
    <ap-responsive-text [text]="mainCropYieldLabel"></ap-responsive-text>
    <ap-responsive-text [text]="mainCropStrawHarvestedLabel"></ap-responsive-text>
  </div>
</div>
<div class="ap-cr-crop-row-detail-box">
  <div class="ap-cr-front-row-noselect">
    <ap-responsive-text [text]="secondCropLabel"></ap-responsive-text>
  </div>
  <div class="ap-cr-back-row-noselect">
    <ap-responsive-text [text]="secondCropYieldLabel"></ap-responsive-text>
  </div>
</div>
